export enum MaterialType {
    MENU = "menu",
    PACKAGING_MENU = "packaging_menu",
    PACKAGING_RAW = "packaging_raw",
    MENU_PREPARE = "menu_prepare",
    ASSEMBLY = "assembly",
    SUB_ASSEMBLY = "sub_assembly",
    BUMBU = "bumbu",
    RAW_MATERIAL = "raw_material",
}
